import { ActionReducerMap, createSelector, createFeatureSelector, ActionReducer, MetaReducer } from '@ngrx/store';
import { RouterStateUrl } from '../../commons';
import * as fromRouter from '@ngrx/router-store';
import { storeFreeze } from 'ngrx-store-freeze';
import * as fromApplication from './app.reducers';
import { AppActions } from './app.actions';

export interface AppState {
    application: fromApplication.State;
    routerReducer: fromRouter.RouterReducerState<RouterStateUrl>;
}

export const reducers:  ActionReducerMap<AppState, AppActions> = {
    application: fromApplication.reducer,
    routerReducer: fromRouter.routerReducer,
};

export function createMetaReducers(freeze = false): MetaReducer<AppState>[] {
    return freeze
        ? [storeFreeze] 
        : [];
}
// Application 
// Application state
export const getApplicationState = createFeatureSelector<fromApplication.State>('application');
// Application selectors
export const getNetworkConnectionStatus = createSelector(getApplicationState, fromApplication.getNetworkConnectionStatus);

export const getSplashScreenStatus = createSelector(getApplicationState, fromApplication.getSplashScreenStatus);

export const getShowSidenav = createSelector(getApplicationState, fromApplication.getShowSidenav);

export const getNavSplashScreenStatus = createSelector(getApplicationState, fromApplication.getNavSplashScreenStatus);
